import { useAppStore } from '../stores/app.js'
import { useI18n } from 'vue-i18n'

/**
 * Composable per la sidebar — adatta le voci alle route del tuo progetto.
 */
export function useSidebar() {
  const appStore = useAppStore()
  const { t } = useI18n()

  function getSidebarItems() {
    const items = [
      {
        id: 'home',
        label: t('nav.home'),
        icon: 'Home',
        to: '/',
      },
    ]

    if (appStore.isAuthenticated) {
      items.push({ separator: true })
      items.push({
        id: 'distribuzione-richieste',
        label: 'Le mie richieste',
        icon: 'Download',
        to: '/distribuzione/richieste',
      })
      items.push({
        id: 'distribuzione-richieste-nuova',
        label: 'Nuova richiesta',
        icon: 'FilePlus',
        to: '/distribuzione/richieste/nuova',
      })

      if (appStore.isRegAdmin) {
        items.push({ separator: true })
        items.push({
          id: 'distribuzione-prodotti',
          label: 'Prodotti',
          icon: 'Package',
          to: '/distribuzione/admin/prodotti',
        })
        items.push({
          id: 'distribuzione-misura-aggregazioni',
          label: 'Aggregazioni',
          icon: 'Sliders',
          to: '/distribuzione/admin/misura-aggregazioni',
        })
        items.push({
          id: 'distribuzione-reti',
          label: 'Reti',
          icon: 'Network',
          to: '/distribuzione/admin/reti',
        })
        items.push({
          id: 'common-stations',
          label: t('nav.commonStations'),
          icon: 'RadioTower',
          to: '/common/stazioni',
        })
        items.push({
          id: 'consistenza-stazioni',
          label: 'Consistenza storico',
          icon: 'ShieldCheck',
          to: '/consistenza/stazioni',
        })
        items.push({
          id: 'distribuzione-limiti-utente',
          label: 'Limiti utente',
          icon: 'Sliders',
          to: '/distribuzione/admin/limiti-utente',
        })
      }

      items.push({ separator: true })
      items.push({
        id: 'profile',
        label: t('nav.profile'),
        icon: 'UserCircle',
        to: '/profile',
      })
    }

    return items
  }

  return { getSidebarItems }
}
